export function removeScripts(src) {
  const scripts = document.querySelectorAll(`[src="${src}"]`);
  const scriptsArray = Array.prototype.slice.call(scripts);
  scriptsArray.forEach(el => el.parentNode.removeChild(el));
}

export default function loadScript(src, callback, timeout) {
  setTimeout(() => {
    const myScript = document.createElement('script');
    myScript.src = src;
    myScript.async = true;
    myScript.onload = callback;
    document.body.appendChild(myScript);
  }, timeout || 500);
}
